// extracted by mini-css-extract-plugin
module.exports = {"warning":"W9rP6WHiRdXRo6PG3FO4","description":"uqlSnBdbsAE50UwvZ4Rb"};